import {
  customAxios
} from "../chunk-RSSSV4W5.mjs";

// src/react-query/auth.ts
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
var sendCode = (sendCodeBody, options, signal) => {
  return customAxios(
    {
      url: `/api/auth/send-code`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sendCodeBody,
      signal
    },
    options
  );
};
var getSendCodeMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return sendCode(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useSendCode = (options) => {
  const mutationOptions = getSendCodeMutationOptions(options);
  return useMutation(mutationOptions);
};
var listCodes = (params, options, signal) => {
  return customAxios(
    { url: `/api/auth/code`, method: "GET", params, signal },
    options
  );
};
var getListCodesQueryKey = (params) => {
  return [`/api/auth/code`, ...params ? [params] : []];
};
var getListCodesQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListCodesQueryKey(params);
  const queryFn = ({
    signal
  }) => listCodes(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListCodes(params, options) {
  const queryOptions = getListCodesQueryOptions(params, options);
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getListCodesSuspenseQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListCodesQueryKey(params);
  const queryFn = ({
    signal
  }) => listCodes(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListCodesSuspense(params, options) {
  const queryOptions = getListCodesSuspenseQueryOptions(params, options);
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getStatusByCodeID = (referenceID, options, signal) => {
  return customAxios(
    { url: `/api/auth/code/${referenceID}/status`, method: "GET", signal },
    options
  );
};
var getGetStatusByCodeIDQueryKey = (referenceID) => {
  return [`/api/auth/code/${referenceID}/status`];
};
var getGetStatusByCodeIDQueryOptions = (referenceID, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetStatusByCodeIDQueryKey(referenceID);
  const queryFn = ({ signal }) => getStatusByCodeID(referenceID, requestOptions, signal);
  return {
    queryKey,
    queryFn,
    enabled: !!referenceID,
    ...queryOptions
  };
};
function useGetStatusByCodeID(referenceID, options) {
  const queryOptions = getGetStatusByCodeIDQueryOptions(referenceID, options);
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetStatusByCodeIDSuspenseQueryOptions = (referenceID, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetStatusByCodeIDQueryKey(referenceID);
  const queryFn = ({ signal }) => getStatusByCodeID(referenceID, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetStatusByCodeIDSuspense(referenceID, options) {
  const queryOptions = getGetStatusByCodeIDSuspenseQueryOptions(
    referenceID,
    options
  );
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var verifyCode = (verifyCodeBody, options, signal) => {
  return customAxios(
    {
      url: `/api/auth/buyer/verify-code`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: verifyCodeBody,
      signal
    },
    options
  );
};
var getVerifyCodeMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return verifyCode(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useVerifyCode = (options) => {
  const mutationOptions = getVerifyCodeMutationOptions(options);
  return useMutation(mutationOptions);
};
var buyerAuthorize = (buyerAuthorizeBody, options, signal) => {
  return customAxios(
    {
      url: `/api/auth/buyer/authorize`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: buyerAuthorizeBody,
      signal
    },
    options
  );
};
var getBuyerAuthorizeMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return buyerAuthorize(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useBuyerAuthorize = (options) => {
  const mutationOptions = getBuyerAuthorizeMutationOptions(options);
  return useMutation(mutationOptions);
};
var buyerLogin = (buyerLoginBody, options, signal) => {
  return customAxios(
    {
      url: `/api/auth/login`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: buyerLoginBody,
      signal
    },
    options
  );
};
var getBuyerLoginMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return buyerLogin(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useBuyerLogin = (options) => {
  const mutationOptions = getBuyerLoginMutationOptions(options);
  return useMutation(mutationOptions);
};
var refreshBuyerToken = (options, signal) => {
  return customAxios(
    { url: `/api/auth/buyer/token/refresh`, method: "POST", signal },
    options
  );
};
var getRefreshBuyerTokenMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = () => {
    return refreshBuyerToken(requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useRefreshBuyerToken = (options) => {
  const mutationOptions = getRefreshBuyerTokenMutationOptions(options);
  return useMutation(mutationOptions);
};
var exchangeOrgToken = (exchangeOrgBody, options, signal) => {
  return customAxios(
    {
      url: `/api/auth/org/token/exchange`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: exchangeOrgBody,
      signal
    },
    options
  );
};
var getExchangeOrgTokenMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return exchangeOrgToken(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useExchangeOrgToken = (options) => {
  const mutationOptions = getExchangeOrgTokenMutationOptions(options);
  return useMutation(mutationOptions);
};
var authorizeService = (options, signal) => {
  return customAxios(
    { url: `/api/auth/service/authorize`, method: "POST", signal },
    options
  );
};
var getAuthorizeServiceMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = () => {
    return authorizeService(requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useAuthorizeService = (options) => {
  const mutationOptions = getAuthorizeServiceMutationOptions(options);
  return useMutation(mutationOptions);
};
var exchangeBuyerToken = (buyerTokenBody, options, signal) => {
  return customAxios(
    {
      url: `/api/auth/buyer/token/exchange`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: buyerTokenBody,
      signal
    },
    options
  );
};
var getExchangeBuyerTokenMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return exchangeBuyerToken(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useExchangeBuyerToken = (options) => {
  const mutationOptions = getExchangeBuyerTokenMutationOptions(options);
  return useMutation(mutationOptions);
};
var createOrgCodes = (createOrgCodeBody, options, signal) => {
  return customAxios(
    {
      url: `/api/auth/org/code`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createOrgCodeBody,
      signal
    },
    options
  );
};
var getCreateOrgCodesMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return createOrgCodes(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useCreateOrgCodes = (options) => {
  const mutationOptions = getCreateOrgCodesMutationOptions(options);
  return useMutation(mutationOptions);
};
var getOrgCodes = (params, options, signal) => {
  return customAxios(
    { url: `/api/auth/org/code`, method: "GET", params, signal },
    options
  );
};
var getGetOrgCodesQueryKey = (params) => {
  return [`/api/auth/org/code`, ...params ? [params] : []];
};
var getGetOrgCodesQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetOrgCodesQueryKey(params);
  const queryFn = ({
    signal
  }) => getOrgCodes(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetOrgCodes(params, options) {
  const queryOptions = getGetOrgCodesQueryOptions(params, options);
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getGetOrgCodesSuspenseQueryOptions = (params, options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetOrgCodesQueryKey(params);
  const queryFn = ({
    signal
  }) => getOrgCodes(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetOrgCodesSuspense(params, options) {
  const queryOptions = getGetOrgCodesSuspenseQueryOptions(params, options);
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var authorizeOrgCode = (authorizeOrgCodeBody, options, signal) => {
  return customAxios(
    {
      url: `/api/auth/org/authorize`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authorizeOrgCodeBody,
      signal
    },
    options
  );
};
var getAuthorizeOrgCodeMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return authorizeOrgCode(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useAuthorizeOrgCode = (options) => {
  const mutationOptions = getAuthorizeOrgCodeMutationOptions(options);
  return useMutation(mutationOptions);
};
var expireOrgCodes = (expireOrgCodeRequestBody, options, signal) => {
  return customAxios(
    {
      url: `/api/auth/org/code/expire`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: expireOrgCodeRequestBody,
      signal
    },
    options
  );
};
var getExpireOrgCodesMutationOptions = (options) => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};
  const mutationFn = (props) => {
    const { data } = props ?? {};
    return expireOrgCodes(data, requestOptions);
  };
  return { mutationFn, ...mutationOptions };
};
var useExpireOrgCodes = (options) => {
  const mutationOptions = getExpireOrgCodesMutationOptions(options);
  return useMutation(mutationOptions);
};
var listAppIdentities = (options, signal) => {
  return customAxios(
    { url: `/api/auth/identity`, method: "GET", signal },
    options
  );
};
var getListAppIdentitiesQueryKey = () => {
  return [`/api/auth/identity`];
};
var getListAppIdentitiesQueryOptions = (options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListAppIdentitiesQueryKey();
  const queryFn = ({ signal }) => listAppIdentities(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListAppIdentities(options) {
  const queryOptions = getListAppIdentitiesQueryOptions(options);
  const query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var getListAppIdentitiesSuspenseQueryOptions = (options) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getListAppIdentitiesQueryKey();
  const queryFn = ({ signal }) => listAppIdentities(requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useListAppIdentitiesSuspense(options) {
  const queryOptions = getListAppIdentitiesSuspenseQueryOptions(options);
  const query = useSuspenseQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}

// src/react-query/auth/model/authErrorReason.ts
var AuthErrorReason = {
  Request_Validation: "Request_Validation",
  Not_Found: "Not_Found",
  Unauthenticated: "Unauthenticated",
  Unauthenticated_Retry_With_PII: "Unauthenticated_Retry_With_PII",
  Unauthenticated_Buyer_Mismatch: "Unauthenticated_Buyer_Mismatch",
  Unauthenticated_Buyer_Not_Found: "Unauthenticated_Buyer_Not_Found",
  Invalid_Token: "Invalid_Token",
  Too_Many_Code_Attempts: "Too_Many_Code_Attempts",
  Too_Many_Unverified_Codes_Sent: "Too_Many_Unverified_Codes_Sent",
  Dependency_Unavailable: "Dependency_Unavailable",
  System_Failure: "System_Failure",
  Service_Unavailable: "Service_Unavailable"
};

// src/react-query/auth/model/deliveryMethodEnum.ts
var DeliveryMethodEnum = {
  SMS: "SMS",
  EMAIL: "EMAIL"
};

// src/react-query/auth/model/disclosureTypeEnum.ts
var DisclosureTypeEnum = {
  SMS: "SMS",
  Email: "Email",
  "terms-of-use": "terms-of-use",
  "privacy-policy-choices": "privacy-policy-choices"
};

// src/react-query/auth/model/models.openapi3/paymentProductType.ts
var PaymentProductType = {
  INSTALLMENTS: "INSTALLMENTS",
  SPLITPAY: "SPLITPAY",
  DEBT_CONSOLIDATION: "DEBT_CONSOLIDATION",
  PERSONAL_LOAN: "PERSONAL_LOAN"
};
export {
  AuthErrorReason,
  DeliveryMethodEnum,
  DisclosureTypeEnum,
  PaymentProductType,
  authorizeOrgCode,
  authorizeService,
  buyerAuthorize,
  buyerLogin,
  createOrgCodes,
  exchangeBuyerToken,
  exchangeOrgToken,
  expireOrgCodes,
  getAuthorizeOrgCodeMutationOptions,
  getAuthorizeServiceMutationOptions,
  getBuyerAuthorizeMutationOptions,
  getBuyerLoginMutationOptions,
  getCreateOrgCodesMutationOptions,
  getExchangeBuyerTokenMutationOptions,
  getExchangeOrgTokenMutationOptions,
  getExpireOrgCodesMutationOptions,
  getGetOrgCodesQueryKey,
  getGetOrgCodesQueryOptions,
  getGetOrgCodesSuspenseQueryOptions,
  getGetStatusByCodeIDQueryKey,
  getGetStatusByCodeIDQueryOptions,
  getGetStatusByCodeIDSuspenseQueryOptions,
  getListAppIdentitiesQueryKey,
  getListAppIdentitiesQueryOptions,
  getListAppIdentitiesSuspenseQueryOptions,
  getListCodesQueryKey,
  getListCodesQueryOptions,
  getListCodesSuspenseQueryOptions,
  getOrgCodes,
  getRefreshBuyerTokenMutationOptions,
  getSendCodeMutationOptions,
  getStatusByCodeID,
  getVerifyCodeMutationOptions,
  listAppIdentities,
  listCodes,
  refreshBuyerToken,
  sendCode,
  useAuthorizeOrgCode,
  useAuthorizeService,
  useBuyerAuthorize,
  useBuyerLogin,
  useCreateOrgCodes,
  useExchangeBuyerToken,
  useExchangeOrgToken,
  useExpireOrgCodes,
  useGetOrgCodes,
  useGetOrgCodesSuspense,
  useGetStatusByCodeID,
  useGetStatusByCodeIDSuspense,
  useListAppIdentities,
  useListAppIdentitiesSuspense,
  useListCodes,
  useListCodesSuspense,
  useRefreshBuyerToken,
  useSendCode,
  useVerifyCode,
  verifyCode
};
//# sourceMappingURL=index.mjs.map